import { useEffect } from 'react';

const loadPerformanceMonitor = () => import('../utils/performanceMonitor');

export const useBundleMetrics = () => {
  useEffect(() => {
    const measureBundleSize = async () => {
      try {
        // Measure initial bundle size
        const resources = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
        const jsResources = resources.filter(resource => 
          resource.name.includes('.js') && !resource.name.includes('node_modules')
        );
        
        const totalSize = jsResources.reduce((total, resource) => 
          total + (resource.transferSize || 0), 0
        );
        
        const _initialSize = jsResources
          .filter(resource => resource.name.includes('index') || resource.name.includes('main'))
          .reduce((total, resource) => total + (resource.transferSize || 0), 0);
        
        const _loadTime = Math.max(...jsResources.map(r => r.responseEnd - r.requestStart));
        
        const cssResources = resources.filter(resource => 
          resource.name.includes('.css')
        );
        
        const cssSize = cssResources.reduce((total, resource) => 
          total + (resource.transferSize || 0), 0
        );
        
        // Defer performance recording until module is loaded
        loadPerformanceMonitor().then(({ performanceMonitor }) => {
          performanceMonitor.recordBundleMetrics({
            totalSize: totalSize + cssSize,
            jsSize: totalSize,
            cssSize,
            chunkCount: jsResources.length,
            timestamp: Date.now(),
          });
        });
        
      } catch {
        // Bundle size measurement failed, continue silently
      }
    };
    
    // Measure after all resources are loaded
    if (document.readyState === 'complete') {
      measureBundleSize();
    } else {
      window.addEventListener('load', measureBundleSize);
      return () => window.removeEventListener('load', measureBundleSize);
    }
  }, []);
};